(() => {
  function init(root) {
    if (root.dataset.bbReady) return;
    root.dataset.bbReady = 'true';
    const related = root.querySelector('[data-bb-related]');
    if (related && window.fetch) {
      const list = related.querySelector('.bb-related-list'), more = related.querySelector('.bb-related-more'), empty = related.querySelector('.bb-related-empty');
      const here = location.pathname.replace(/\/$/, '');
      // a.bb-reco-card のクリックはサイト計測（site_events）に残り、翌日の並び替えでクリック率として使われる
      const render = items => {
        items.forEach(item => {
          const li = document.createElement('li'), a = document.createElement('a');
          a.className = 'bb-reco-card'; a.href = item.path;
          if (item.athlete) a.dataset.kind = 'athlete';
          if (item.img) { const img = document.createElement('img'); img.src = item.img; img.alt = ''; img.loading = 'lazy'; img.width = 240; img.height = 135; a.append(img); }
          else { const img = document.createElement('img'); img.src = 'https://fitpeak-ai-org.vercel.app/api/og?k=' + encodeURIComponent(item.athlete ? '選手名鑑' : 'KINNIKU TIMES') + '&t=' + encodeURIComponent(item.title); img.alt = ''; img.loading = 'lazy'; img.width = 240; img.height = 135; a.append(img); }
          const date = document.createElement('span'); date.className = 'bb-related-date'; date.textContent = item.athlete ? '選手名鑑' : item.date;
          const title = document.createElement('span'); title.className = 'bb-related-title'; title.textContent = item.title;
          a.append(date, title); li.append(a); list.append(li);
        });
        list.hidden = false; more.hidden = false; empty.hidden = true;
      };
      const atom = () => {
        if (!window.DOMParser) return Promise.reject();
        return fetch('/blogs/kinniku-times/tagged/' + related.dataset.bbRelated + '.atom').then(r => r.ok ? r.text() : Promise.reject()).then(text => {
          const doc = new DOMParser().parseFromString(text, 'application/xml');
          return [...doc.querySelectorAll('entry')].map(entry => {
            const href = entry.querySelector('link')?.getAttribute('href') || '';
            const path = href.replace(/^https?:\/\/[^/]+/, '').split('?')[0];
            const html = entry.querySelector('summary, content')?.textContent || '';
            const img = (html.match(/<img[^>]+src="([^"]+)"/) || [])[1] || '';
            return { path, title: entry.querySelector('title')?.textContent || '', date: (entry.querySelector('published')?.textContent || '').slice(0, 10).replace(/-/g, '.'), img };
          }).filter(item => item.path && item.path !== here && !item.title.includes('プロフィール・戦績・経歴・公式SNS')).slice(0, 6);
        });
      };
      const reco = related.dataset.bbReco
        ? fetch(related.dataset.bbReco + '?path=' + encodeURIComponent(here)).then(r => r.ok ? r.json() : Promise.reject()).then(d => (d.items || []).filter(i => i.path !== here).slice(0, 8).map(i => ({ path: i.path, title: i.title, img: i.image, athlete: i.athlete, date: (i.date || '').replace(/-/g, '.') })))
        : Promise.resolve([]);
      // 選手カードは記事のアイキャッチ（共通の写真）ではなく、選手本人の写真か名前のカードにする
      const photos = related.dataset.bbPhotos ? fetch(related.dataset.bbPhotos).then(r => r.ok ? r.json() : {}).catch(() => ({})) : Promise.resolve({});
      const withPhotos = items => photos.then(map => items.map(i => i.athlete ? { ...i, img: map[i.path] || '' } : i));
      reco.catch(() => []).then(items => items.length ? withPhotos(items) : atom()).then(items => {
        if (!items.length) { empty.innerHTML = ''; empty.append('関連記事は準備中です。'); const a = document.createElement('a'); a.href = '/blogs/kinniku-times'; a.textContent = 'KINNIKU TIMESの最新記事を見る'; empty.append(a); return; }
        render(items);
      }).catch(() => { empty.textContent = '関連記事は記事一覧からご確認ください。'; });
    }
    const input = root.querySelector('[data-bb-search]');
    if (input) {
      const cards = [...root.querySelectorAll('[data-bb-athlete]')];
      const normalize = value => value.normalize('NFKC').toLowerCase().replace(/[ぁ-ゖ]/g, c => String.fromCharCode(c.charCodeAt(0) + 0x60)).replace(/[\s・.'’\-_／/()（）]/g, '');
      const tokens = value => value.normalize('NFKC').trim().split(/\s+/).map(normalize).filter(Boolean);
      let groups = [];
      try { groups = JSON.parse(root.querySelector('[data-bb-aliases]')?.textContent || '[]'); } catch (error) { groups = []; }
      // A token matches the card text directly, or any alias group that contains the token (e.g. JBBF = 日本ボディビル連盟).
      const variants = token => [token, ...groups.flatMap((group, i) => group.some(term => term === token || (token.length > 1 && term.includes(token))) ? ['zzg' + i + 'zz'] : [])];
      const haystacks = new Map(cards.map(card => [card, normalize(card.dataset.bbAthlete)]));
      root.querySelector('[data-bb-search-wrap]').hidden = false;
      const division = root.querySelector('[data-bb-division]');
      if (division) ['ボディビル', 'メンズフィジーク', 'クラシックフィジーク', '女子フィジーク', '女子ボディビル', 'ビキニフィットネス', 'ボディフィットネス', 'YouTuber'].filter(name => cards.some(card => name==='YouTuber' ? card.dataset.bbCreator==='true' : card.dataset.bbDivisionName?.includes(name))).forEach(name => {
        const option = document.createElement('option'); option.value = name; option.textContent = name; division.append(option);
      });
      const updateAthletes = () => {
        const queryTokens = tokens(input.value);
        cards.forEach(card => { card.hidden = !queryTokens.every(token => variants(token).some(v => haystacks.get(card).includes(v))) || Boolean(division?.value && !(division.value==='YouTuber' ? card.dataset.bbCreator==='true' : card.dataset.bbDivisionName.includes(division.value))); });
        const count = cards.filter(card => !card.hidden).length;
        root.querySelector('[data-bb-no-match]').hidden = count > 0;
        const counter = root.querySelector('[data-bb-athlete-count]');
        if (counter) counter.textContent = `${count} 名 / 全 ${cards.length} 名`;
      };
      input.addEventListener('input', updateAthletes);
      division?.addEventListener('change', updateAthletes); updateAthletes();
    }
    const filter = root.querySelector('[data-bb-organizer-filter]');
    if (filter) {
      const events = [...root.querySelectorAll('[data-bb-organizer]')];
      [...new Set(events.map(item => item.dataset.bbOrganizer))].forEach(name => {
        const option = document.createElement('option'); option.value = name; option.textContent = name; filter.append(option);
      });
      const update = () => {
        events.forEach(item => { item.hidden = Boolean(filter.value && item.dataset.bbOrganizer !== filter.value); });
        root.querySelector('[data-bb-event-count]').textContent = `${events.filter(item => !item.hidden).length} 件の大会`;
      };
      root.querySelector('[data-bb-filter-wrap]').hidden = false;
      filter.addEventListener('change', update); update();
    }
    root.querySelectorAll('[data-bb-source-links]').forEach(el => {
      const lines = el.innerText.split('\n'); el.replaceChildren();
      lines.filter(Boolean).forEach(line => {
        const row = document.createElement('span'); row.className = 'bb-source-line';
        const match = line.match(/https:\/\/[^\s]+/);
        if (match) {
          row.append(document.createTextNode(line.slice(0, match.index)));
          const link = document.createElement('a'); link.href = match[0]; link.textContent = match[0]; link.target = '_blank'; link.rel = 'noopener noreferrer'; row.append(link);
        } else row.textContent = line;
        el.append(row);
      });
    });
    root.querySelectorAll('[data-bb-post]').forEach(box => {
      const button = box.querySelector('button');
      button.addEventListener('click', () => {
        let url;
        try { url = new URL(box.dataset.bbPost); } catch { return; }
        let src = '';
        if (['www.instagram.com', 'instagram.com'].includes(url.hostname) && /^\/(p|reel)\/[\w-]+\/?$/.test(url.pathname)) src = `https://www.instagram.com${url.pathname.replace(/\/$/, '')}/embed/`;
        if (['www.youtube.com', 'youtube.com'].includes(url.hostname) && /^[\w-]{11}$/.test(url.searchParams.get('v') || '')) src = `https://www.youtube-nocookie.com/embed/${url.searchParams.get('v')}`;
        if (!src) { button.textContent = '投稿リンクからご覧ください'; button.disabled = true; return; }
        const iframe = document.createElement('iframe'); iframe.src = src; iframe.title = '選手の公式SNS投稿'; iframe.loading = 'lazy'; iframe.allowFullscreen = true; iframe.className = 'bb-post-frame'; iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        button.replaceWith(iframe);
      });
    });
  }
  // 「次の選手」ボタン: 基本情報を読み終えたら出し、おすすめ記事の枠が見えている間は隠す（枠の中にリンクがあるため）
  function nextButton(root) {
    const btn = root.querySelector('[data-bb-next]');
    const facts = root.querySelector('#facts');
    if (!btn || !facts) return;
    btn.hidden = false;
    const tail = [root.querySelector('#related-articles'), root.querySelector('#same-division')].filter(Boolean);
    const update = () => {
      const passed = facts.getBoundingClientRect().bottom < 0;
      const inTail = tail.some(el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
      btn.classList.toggle('is-on', passed && !inTail);
    };
    addEventListener('scroll', update, { passive: true });
    update();
  }
  document.querySelectorAll('[data-bb-hub]').forEach(root => { init(root); nextButton(root); });
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bb-hub]').forEach(init));
})();
